import styled, { css } from 'styled-components';

// Offset position to account for arrow size and placement
const getArrowHeightOffset = (orientation) => {
  switch (orientation) {
    case 'top':
      return -30;
    case 'bottom':
      return 30;
    case 'right':
      return -40;
    case 'left':
      return -40;
    default:
      return 0;
  }
};

// Offset position to account for arrow size and placement
const getArrowWidthOffset = (orientation) => {
  switch (orientation) {
    case 'top':
      return -40;
    case 'bottom':
      return -40;
    case 'right':
      return 30;
    case 'left':
      return -30;
    default:
      return 0;
  }
};

export const TourContainer = styled.div`
  z-index: 1;
  display: flex;
  ${({ orientation }) => {
    // Set flex direction based on orientation so the arrow will get correct position
    let direction = 'column'; // orientation === 'top'
    if (orientation === 'bottom') {
      direction = 'column-reverse';
    } else if (orientation === 'left') {
      direction = 'row';
    } else if (orientation === 'right') {
      direction = 'row-reverse';
    }
    return css`
      flex-direction: ${direction};
    `;
  }}
  position: fixed;
  ${({ offsetHeight, offsetWidth, orientation }) => {
    // position should be absolute relative to the browser window,
    // then offset is used to position it on the screen
    if (orientation === 'right') {
      return css`
        top: ${offsetHeight + getArrowHeightOffset(orientation)}px;
        right: ${window.innerWidth - offsetWidth - getArrowWidthOffset(orientation)}px;
      `;
    } else if (orientation === 'bottom') {
      return css`
        bottom: ${window.innerHeight - offsetHeight - getArrowHeightOffset(orientation)}px;
        left: ${offsetWidth + getArrowWidthOffset(orientation)}px;
      `;
    }
    return css`
      top: ${offsetHeight + getArrowHeightOffset(orientation)}px;
      left: ${offsetWidth + getArrowWidthOffset(orientation)}px;
    `;
  }}
`;

export const TourHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 5px;

  > :is(h1, h2, h3, h4, h5, h6) {
    color: #00b8b8;
  }
`;

export const TourText = styled.p`
  font-size: 14px;
`;

export const IconButtonContainer = styled.button`
  border: 0;
  line-height: 0;
  height: 2rem;
  width: 2rem;
  border-radius: 1rem;
  background: transparent;
  color: white;
  &:hover {
    ${({ hoverColor, hoverBackgroundColor }) => {
      return css`
        color: ${hoverColor || '#295c88'};
        background-color: ${hoverBackgroundColor || 'white'};
      `;
    }}
  }
`;

export const ButtonIcon = styled.i.attrs(({ icon }) => ({
  // icon is a required prop
  className: icon,
}))`
  font-size: 1rem;
`;

export const TourContent = styled.div`
  padding: 10px;
  background-color: rgb(0, 0, 0, 0.85);
  color: white;
  border: solid 1px;
  border-color: ${({ isDarkMode }) =>
    css`
      ${isDarkMode ? '#00b8b8' : 'black'}
    `};
  // Hide the border in arrow direction since it does not break for arrow
  ${({ orientation }) =>
    ['top', 'bottom', 'left', 'right'].includes(orientation)
      ? css`
          border-${orientation}: transparent 0px;
        `
      : css`
          border: transparent 0px;
        `}
`;

export const NextButton = styled.span`
  user-select: none;
  cursor: pointer;
  border-radius: 5px;
  color: white;
  background-color: #00b8b8;
  border: solid 2px;
  border-color: transparent;
  padding: 0px 5px 0px 5px;
  &:hover {
    background-color: white;
    color: #00b8b8;
    border-color: #00b8b8;
  }
`;

export const TourArrow = styled.span`
  width: 50px;
  height: 50px;
  position: relative;
  display: block;
  border: inset 25px;
  border-style: solid;
  ${({ orientation }) => {
    // this is the logic transforming the span into an arrow
    switch (orientation) {
      case 'top':
        return css`
          border-color: transparent transparent rgb(0, 0, 0, 0.85) transparent !important;
          left: 15px;
        `;
      case 'bottom':
        return css`
          border-color: rgb(0, 0, 0, 0.85) transparent transparent transparent !important;
          left: 15px;
        `;
      case 'right':
        return css`
          border-color: transparent transparent transparent rgb(0, 0, 0, 0.85) !important;
          top: 15px;
        `;
      case 'left':
        return css`
          border-color: transparent rgb(0, 0, 0, 0.85) transparent transparent !important;
          top: 15px;
        `;
      default:
        return css`
          border-color: transparent;
        `;
    }
  }};
`;
